<template>
  <div class="row m-0">
    <div class="col-12 bold my-1" v-if="categoryItem != 'uncategorised' && filteredProducts.length > 0" :id="categories.id">
      {{categoryItem}}
    </div>
    <!-- <app-product-item v-for="prod in products" :item="prod" :key="prod.id" :displayList="displayList" @edit="setToEdit(prod)" @editImg="setImgToEdit(prod)"></app-product-item>
    <app-product-item-empty key="emptyProd" @add="setToEdit({})"></app-product-item-empty> -->
    <app-product-item v-for="prod in filteredProducts" :item="prod" :key="prod.id" :displayList="displayList" @edit="setToEdit(prod)" @editimg="setImgToEdit(prod)"></app-product-item>
    <div class="col-12 p-0" v-if="productToEdit">
      <div class="row m-0">
        <app-product-edit :item="productToEdit" :key="productToEdit.id" @close="updateProduct" @editimg="setImgToEdit"></app-product-edit>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: ['categoryItem', 'search', 'products'],
  components: {
    'app-product-edit': () => import('@/components/product/ProductEdit.vue'),
    // 'app-product-img-edit': () => import('@/components/product/ProductImgGallery.vue'),
    'app-product-item': () => import('@/components/product/ProductItem.vue')
    // 'app-product-item-empty': () => import('@/components/product/ProductItemEmpty.vue')
  },
  data () {
    return {
      displayList: false,
      productToEdit: null,
      productImgToEdit: null,
      categories: {}
    }
  },
  computed: {
    filteredProducts () {
      const search = this.search.toLowerCase().trim()
      return this.products.filter((product) => {
        if (search) {
          return product.filter(product => !product.isDeleted).title.toLowerCase().indexOf(search) > -1
        } else {
          return !product.isDeleted
        }
      })
    }
  },
  mounted () {
    var stringVal = this.categoryItem
    var newStringVal = stringVal.replace(/ /g, '')
    var category = {
      id: newStringVal,
      cat: stringVal
    }
    this.categories = category
  },
  methods: {
    ...mapActions(['addItem', 'updateItem']),
    setImgToEdit (prod) {
      this.productImgToEdit = prod
    },
    setToEdit (prod) {
      this.$emit('setToEdit', prod)
      // this.productToEdit = prod
    },
    updateProduct (prod) {
      if (prod) {
        if (prod.key) {
          this.updateItem(prod)
        } else {
          this.addItem(prod)
        }
      }
      this.setToEdit()
      this.setImgToEdit()
    },
    filterSearch (val) {
      this.search = val
    },
    selectCategory (val) {
      this.categoryFilter = val
    }
  }
}
</script>
